import Component from "gia/Component";
import Accordion from "accordion-js";
import gsap from "gsap";
import Channels from "../base/channels";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.accordions = this.DOM.view.querySelectorAll(".ac");

    this.buildAccordions();
  }

  buildAccordions() {
    this.instanceAccordion = new Accordion(this.DOM.view, {
      onOpen: () => this.refresh(),
      onClose: () => this.refresh(),
    });
    Channels.on("accordions::close", () => {
      for (let [i, a] of this.accordions.entries()) {
        if (a.classList.contains("is-active")) {
          this.instanceAccordion.close(i);
        }
      }
    });
  }

  refresh() {
    gsap.delayedCall(0.1, () => {
      Channels.emit("smoothscroll::redraw");
    });
  }

  unmount() {
    this.instanceAccordion.destroy();
  }
}
